export default __webpack_public_path__ + "static/media/2113.834ee9a4.png";